/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {InviteLinkUpdateModel} from "../../models/invite-link-update-model";
import {InviteLinkModel} from "../../models/invite-link-model";


export interface InviteLinksPutParams {
    body?: InviteLinkUpdateModel
}

export function inviteLinksPut(http: HttpClient, rootUrl: string, params: InviteLinksPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<InviteLinkModel>> {
    const rb = new RequestBuilder(rootUrl, inviteLinksPut.PATH, 'put');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.body(params.body, 'application/json');

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<InviteLinkModel>;
        })
    );
}

inviteLinksPut.PATH = '/api/v1/invite-links';
